import axios from '../axios';
import config from '../../config';

const apis = {
	// 添加伤病卡片
	injuryCardAdd(data) {
		return axios(`${config.injuryUrl}/card`, {
			method: 'post',
			data,
		})
	},
	// 删除伤病卡片
	injuryCardDelete(data) {
		return axios(`${config.injuryUrl}/card/delete`, {
			method: 'post',
			data,
		})
	},
	// 编辑伤病卡片
	injuryCardUpdate(data) {
		return axios(`${config.injuryUrl}/card/update`, {
			method: 'post',
			data,
		})
	},
	// 根据球员id数组查询所有伤病卡片
	injuryDetailList(data) {
		return axios(`${config.injuryUrl}/card/list/current`, {
			method: 'post',
			data,
		})
	},
	// 根据单个球员id查询历史伤病
	injuryHistoryList(data) {
		return axios(`${config.injuryUrl}/card/list/player/history`, {
			method: 'post',
			data,
		})
	},
	// 查询单个伤病卡片详情
	injuryCardDetail(data) {
		return axios(`${config.injuryUrl}/card/detail`, {
			method: 'post',
			data,
		})
	},
	// 查询单个伤病卡片的治疗记录
	injuryCardTreatmentList(data) {
		return axios(`${config.injuryUrl}/treatment/list`, {
			method: 'post',
			data,
		})
	},
	// 伤病卡片康复
	injuryCardTreatment(data) {
		return axios(`${config.injuryUrl}/card/recovery`, {
			method: 'post',
			data,
		})
	},
	// 新增治疗记录
	injuryCardTreatmentAdd(data) {
		return axios(`${config.injuryUrl}/treatment`, {
			method: 'post',
			data,
		})
	},
	// 修改治疗记录
	injuryCardTreatmentUpdate(data) {
		return axios(`${config.injuryUrl}/treatment/update`, {
			method: 'post',
			data,
		})
	},
	// 删除治疗记录
	injuryCardTreatmentDelete(data) {
		return axios(`${config.injuryUrl}/treatment/delete`, {
			method: 'post',
			data,
		})
	},
};
export default apis;
